import React, { useState } from "react";
import "../Table/Table.css";
import Loading from "../Loading";
import DataTable from "../DataTable/DataTable";

function ServiceDetail({ data, contractNumber }) {
  const [loadingFull, setLoadingFull] = useState(false);

  const handleDownloadCSV = () => {
    const csvRows = [];
    const headers = ["Service Id", "Service Name", "Service Description"];
    csvRows.push(headers.join(","));

    data?.data?.forEach((invoice) => {
      const row = [
        invoice?.service_id || "N/A",
        invoice?.service_name || "N/A",
        invoice?.service_description || "N/A",
      ].map((value) => `"\t${String(value).replace(/"/g, '""')}"`);
      csvRows.push(row.join(","));
    });

    const csvContent = "data:text/csv;charset=utf-8," + csvRows.join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute(
      "download",
      `Location_Service_Details_${contractNumber}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const columns = [
    { field: "service_id", headerName: "Service ID", width: 130 },
    { field: "service_name", headerName: "Service Name", width: 200 },
    {
      field: "service_description",
      headerName: "Service Description",
      width: 250,
    },
  ];

  const rows =
    data?.data?.map((invoice, index) => ({
      id: index,
      service_id: invoice?.service_id || "N/A",
      service_name: invoice?.service_name || "N/A",
      service_description: invoice?.service_description || "N/A",
    })) || [];

  return (
    <>
      {loadingFull && <Loading />}

      <div className="table-header">
        <h2>Location ID - {contractNumber} (Services)</h2>
        <button
          onClick={handleDownloadCSV}
          style={{
            background: "#4CAF50",
            color: "#fff",
            padding: "10px",
            border: "none",
            cursor: "pointer",
          }}
        >
          Download CSV
        </button>
      </div>
      <DataTable columns={columns} rows={rows} />
    </>
  );
}

export default ServiceDetail;
